import { Language } from '@generated/base-types';
import { EntityData } from '@new/common/utils/entity-data';
import { Selector } from '@ngxs/store';
import {
  PoolAffiliationFragment,
  PoolDimensionFragment,
  PoolLabelFragment,
  PoolMetadataFragment,
  PoolRevisionStatusFragment
} from '../../lib/services/pool/load-pool.generated';
import { UnlockedExamFragment } from '../../lib/services/tasks/unlocked-exams.generated';
import { PoolState } from './pool.state';
import { PoolStateModel } from './pool.state.model';

export class PoolSelectors {
  @Selector([PoolState])
  public static pool(state: PoolStateModel): EntityData<PoolMetadataFragment> {
    return state.pool;
  }

  @Selector([PoolState])
  public static poolId(state: PoolStateModel): string | undefined {
    return state.pool.data?.id;
  }

  @Selector([PoolState])
  public static poolName(state: PoolStateModel): string | undefined {
    return state.pool.data?.name;
  }

  @Selector([PoolState])
  public static isSelfAssessmentAllowed(
    state: PoolStateModel
  ): boolean | undefined {
    return state.pool.data?.selfAssessment;
  }

  @Selector([PoolState])
  public static authors(state: PoolStateModel): string[] {
    return state.pool.data?.authors ?? [];
  }

  @Selector([PoolState])
  public static supervisors(state: PoolStateModel): string[] {
    return state.pool.data?.supervisors ?? [];
  }

  @Selector([PoolState])
  public static affiliations(state: PoolStateModel): PoolAffiliationFragment[] {
    return state.pool.data?.affiliations ?? [];
  }

  @Selector([PoolState])
  public static languages(state: PoolStateModel): Language[] {
    return state.pool.data?.languages ?? [];
  }

  @Selector([PoolState])
  public static dimensions(state: PoolStateModel): PoolDimensionFragment[] {
    return state.pool.data?.dimensions ?? [];
  }

  @Selector([PoolState])
  public static revisionStatuses(
    state: PoolStateModel
  ): PoolRevisionStatusFragment[] {
    return state.pool.data?.revisionStatus ?? [];
  }

  @Selector([PoolState])
  public static labels(state: PoolStateModel): PoolLabelFragment[] {
    return state.pool.data?.labels ?? [];
  }

  @Selector([PoolState])
  public static poolExamIds(state: PoolStateModel): string[] {
    return state.pool.data?.exams?.map((exam: { id: string }) => exam.id) ?? [];
  }

  @Selector([PoolState])
  public static unlockedExams(state: PoolStateModel): UnlockedExamFragment[] {
    return state.unlockedExams.data ?? [];
  }

  @Selector([PoolState])
  public static poolTaskIds(state: PoolStateModel): number[] {
    return state.pool.data?.tasks?.map((task: { id: number }) => task.id) ?? [];
  }
}
